/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { FullTransferDetails } from '../model/fullTransferDetails';
import { PaginatedResultComposedTransferBasicInfo } from '../model/paginatedResultComposedTransferBasicInfo';
import { RestError } from '../model/restError';
import { SearchRequest } from '../model/searchRequest';
import { TransferBlockRequest } from '../model/transferBlockRequest';
import { TransferNote } from '../model/transferNote';
import { TransferNoteCreation } from '../model/transferNoteCreation';
import { TransferReleaseRequest } from '../model/transferReleaseRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MtcTransferServiceControllerService {

    protected basePath = 'https://mtc-ms-backoffice-api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * blockTransfer
     * 
     * @param idTransfer idTransfer
     * @param transferBlockRequest transferBlockRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public blockTransferUsingPOST(idTransfer: number, transferBlockRequest: TransferBlockRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public blockTransferUsingPOST(idTransfer: number, transferBlockRequest: TransferBlockRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public blockTransferUsingPOST(idTransfer: number, transferBlockRequest: TransferBlockRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public blockTransferUsingPOST(idTransfer: number, transferBlockRequest: TransferBlockRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idTransfer === null || idTransfer === undefined) {
            throw new Error('Required parameter idTransfer was null or undefined when calling blockTransferUsingPOST.');
        }

        if (transferBlockRequest === null || transferBlockRequest === undefined) {
            throw new Error('Required parameter transferBlockRequest was null or undefined when calling blockTransferUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/transfer/${encodeURIComponent(String(idTransfer))}/block`,
            transferBlockRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createTransferNote
     * 
     * @param id id
     * @param creationNote creationNote
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTransferNoteUsingPOST(id: number, creationNote: TransferNoteCreation, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public createTransferNoteUsingPOST(id: number, creationNote: TransferNoteCreation, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public createTransferNoteUsingPOST(id: number, creationNote: TransferNoteCreation, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public createTransferNoteUsingPOST(id: number, creationNote: TransferNoteCreation, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling createTransferNoteUsingPOST.');
        }

        if (creationNote === null || creationNote === undefined) {
            throw new Error('Required parameter creationNote was null or undefined when calling createTransferNoteUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/transfer/${encodeURIComponent(String(id))}/note`,
            creationNote,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTransferDetails
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTransferDetailsUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<FullTransferDetails>;
    public getTransferDetailsUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FullTransferDetails>>;
    public getTransferDetailsUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FullTransferDetails>>;
    public getTransferDetailsUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTransferDetailsUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<FullTransferDetails>(`${this.basePath}/transfer/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * releaseTransfer
     * 
     * @param idTransfer idTransfer
     * @param transferReleaseRequest transferReleaseRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public releaseTransferUsingPOST(idTransfer: number, transferReleaseRequest: TransferReleaseRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public releaseTransferUsingPOST(idTransfer: number, transferReleaseRequest: TransferReleaseRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public releaseTransferUsingPOST(idTransfer: number, transferReleaseRequest: TransferReleaseRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public releaseTransferUsingPOST(idTransfer: number, transferReleaseRequest: TransferReleaseRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idTransfer === null || idTransfer === undefined) {
            throw new Error('Required parameter idTransfer was null or undefined when calling releaseTransferUsingPOST.');
        }

        if (transferReleaseRequest === null || transferReleaseRequest === undefined) {
            throw new Error('Required parameter transferReleaseRequest was null or undefined when calling releaseTransferUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/transfer/${encodeURIComponent(String(idTransfer))}/release`,
            transferReleaseRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchNotesByTransferId
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchNotesByTransferIdUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<Array<TransferNote>>;
    public searchNotesByTransferIdUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TransferNote>>>;
    public searchNotesByTransferIdUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TransferNote>>>;
    public searchNotesByTransferIdUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling searchNotesByTransferIdUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<Array<TransferNote>>(`${this.basePath}/transfer/${encodeURIComponent(String(id))}/note`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchTransfers
     * 
     * @param filter filter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchTransfersUsingPOST(filter: SearchRequest, observe?: 'body', reportProgress?: boolean): Observable<PaginatedResultComposedTransferBasicInfo>;
    public searchTransfersUsingPOST(filter: SearchRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedResultComposedTransferBasicInfo>>;
    public searchTransfersUsingPOST(filter: SearchRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedResultComposedTransferBasicInfo>>;
    public searchTransfersUsingPOST(filter: SearchRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling searchTransfersUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PaginatedResultComposedTransferBasicInfo>(`${this.basePath}/transfer/search`,
            filter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
